import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { buttonStyle } from '../../../theme/buttons'
import { corporateColor, whiteBackgroundColor } from '../../../theme/colors'

interface Props {
  label: string
  isActive: boolean
  onPress: () => void
}

export const ButtonForm = ({ label, onPress, isActive }: Props) => {
  return (
    <TouchableOpacity
      style={[buttonStyle.basic, styles.primary, isActive && styles.active]}
      onPress={onPress}
      activeOpacity={0.7}
    >
      <View style={styles.leftColumn}>
        <View style={[styles.circle, isActive && styles.circleActive]} />
      </View>
      <View style={styles.rigthColumn}>
        <Text style={[styles.primaryText, isActive && styles.textActive]}>{label}</Text>
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  primary: {
    backgroundColor: 'white',
    width: '90%',
    marginTop: 15,
    color: corporateColor,
    borderWidth: 0.6,
    borderColor: corporateColor,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
  },
  active: {
    backgroundColor: corporateColor,
  },
  textActive: {
    color: whiteBackgroundColor,
    fontWeight: 'bold',
  },
  circleActive: {
    borderColor: whiteBackgroundColor,
    borderWidth: 4,
  },
  primaryText: {
    color: corporateColor,
    textAlign: 'center',
  },
  circle: {
    borderColor: corporateColor,
    borderWidth: 0.7,
    width: 40,
    height: 40,
    borderRadius: 50,
  },
  leftColumn: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  rigthColumn: {
    flex: 2,
    flexDirection: 'row',
    justifyContent: 'center',
  },
})
